import Gb1SaleReport from "../components/Gb1SaleReport";

const Gb1SaleReportPage = () => {
  return <Gb1SaleReport />;
};

export default Gb1SaleReportPage;
